export default {
  USER_DETAIL: null,
};
